module.exports = __webpack_public_path__ + "img/user-settings.05861a99.svg";